export enum IrbDialogsEvents {
    SHOW_PR_EXPLANATION = "IRBDIALOGSEVENTS.SHOW_PR_EXPLANATION",
    SHOW_PR_COST_BASIS = "IRBDIALOGSEVENTS.SHOW_PR_COST_BASIS",
    PR_COST_BASIS_CLOSED = "IRBDIALOGSEVENTS.PR_COST_BASIS_CLOSED",
    SHOW_PR_AUDIT = "IRBDIALOGSEVENTS.SHOW_PR_AUDIT",
    SHOW_PR_EXPORT_PDF = "IRBDIALOGSEVENTS.SHOW_PR_EXPORT_PDF",
    SHOW_PR_EXPORT_PDF_LEGACY = "IRBDIALOGSEVENTS.SHOW_PR_EXPORT_PDF_LEGACY",
    SHOW_PR_RESUBMIT = "IRBDIALOGSEVENTS.SHOW_PR_RESUBMIT",
    SHOW_SECURITY_USAGE_WARNING = "IRBDIALOGSEVENTS.SHOW_SECURITY_USAGE_WARNING",
    SHOW_DELETE_COMPONENT_SECURITIES_DIALOG = "IRBDIALOGSEVENTS.SHOW_DELETE_COMPONENT_SECURITIES_DIALOG",
    SHOW_MODEL_USED_IN_REBALANCE_DIALOG="IRBDIALOGSEVENTS.SHOW_MODEL_USED_IN_REBALANCE_DIALOG",
    SHOW_ANNOUNCEMENTS = "IRBDIALOGSEVENTS.SHOW_ANNOUNCEMENTS",
    SHOW_THRESHOLD_EXCEEDED_DIALOG = "IRBDIALOGSEVENTS.SHOW_THRESHOLD_EXCEEDED_DIALOG",
    SHOW_FINMASON_TRAIN_SSO = "IRBDIALOGSEVENTS.SHOW_FINMASON_TRAIN_SSO",
    SHOW_PORTFOLIO_CUSTOM_LABELS_MODIFY = "IRBDIALOGSEVENTS.SHOW_PORTFOLIO_CUSTOM_LABELS_MODIFY",
    SHOW_PORTFOLIO_MULTIEDIT_VIEW = "IRBDIALOGSEVENTS.SHOW_PORTFOLIO_MULTIEDIT_VIEW",
    SHOW_ACCOUNT_MULTIEDIT_VIEW = "IRBDIALOGSEVENTS.SHOW_ACCOUNT_MULTIEDIT_VIEW",
    SHOW_VIEW_ASSET_CLASSES_DIALOG = "IRBDIALOGSEVENTS.SHOW_VIEW_ASSET_CLASSES_DIALOG",
    SHOW_QOE_RESULT_DIALOG = "IRBDIALOGSEVENTS.SHOW_QOE_RESULT_DIALOG"
}
